var map = {
	"./chips_10.png": 9694,
	"./chips_100.png": 297,
	"./chips_1000.png": 2949,
	"./chips_10000.png": 8537,
	"./chips_100000.png": 9504,
	"./chips_20.png": 3962,
	"./chips_200.png": 9304,
	"./chips_2000.png": 9549,
	"./chips_20000.png": 5369,
	"./chips_200000.png": 9060,
	"./chips_50.png": 4811,
	"./chips_500.png": 4427,
	"./chips_5000.png": 9674,
	"./chips_50000.png": 1693,
	"./chips_500000.png": 5836,
	"./chips_Infinity.png": 9208
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5676;